export { ZardDialogComponent, ZardDialogOptions, ZardDialogModule } from './dialog.component'
export { type OnClickCallback as DialogOnClickCallback } from './dialog.component'
export * from './dialog.service'
export * from './dialog-ref'
export * from './dialog.variants'
